/* global Editor */

window['profile_templates#index'] = function () {
  $('input.profile_template_checkbox').on('click', function (e) {
    const value = e.target.value
    const checked = e.target.checked

    // turns the default button on and off if template is active \ deactivated
    const disabled = !checked
    $('#default_template_' + value).prop('disabled', disabled)

    const action = checked ? 'activate_profile_template' : 'deactivate_profile_template'
    $.ajax({
      type: 'POST',
      url: (`profile_templates/${this.value}/${action}`),
      data: { id: value },
      success: showSaveMessage($(e.target).parents('tr'))
    })
  })

  function showSaveMessage (tr) {
    $('.save-message', tr).fadeIn(function () {
      setTimeout(() => $('.save-message', tr).fadeOut(), 1000)
    })
  }

  $(document).on('click', 'input[name="default_template"]', function () {
    $.post(`profile_templates/${this.value}/set_default`)
  })
}

window['profile_templates#new'] = window['profile_templates#edit'] = function () {
  initCustomTabHandler()

  const preview = $('#candidates_profile_preview .profile-preview')

  // Preview
  $('#candidates_profile_preview').on('show.bs.modal', function () {
    preview.addClass('loading')
    $.ajax({
      method: 'POST',
      url: $('form.edit_profile_template').data('preview-url'),
      dataType: 'script',
      data: {
        template: $('#profile_template_template').val(),
        css: $('#profile_template_css').val(),
        person_card: $('#profile_template_person_card').val(),
        work_experience: $('#profile_template_work_experience').val(),
        education: $('#profile_template_education').val(),
        projects_list: $('#profile_template_projects_list').val()
      },
      success: function (response) {
        preview.removeClass('loading').html(response)
      }
    })
  })

  // Hints
  $('.markup-hint').popover({
    placement: 'left',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-body profile-markup-hint"></div></div>'
  })

  $('.qform-hint').popover({
    html: true,
    sanitize: false
  })
  $('.markup-hint').on('inserted.bs.popover', function (e) {
    const editorElement = document.querySelector('.popover-body .profile-markup-hint')
    const interval = setInterval(() => {
      if (editorElement) {
        clearInterval(interval)
        Editor.initCodeEditor(editorElement, { readonly: true }).then(() => Helpers.initLiquidTags())
      }
    }, 100) // wait for popover to be inserted into DOM
  })
  $('.qform-hint').on('inserted.bs.popover', function (e) {
    Helpers.initLiquidTags()
  })
}

function initCustomTabHandler () {
  const tabContent = document.querySelector('#template')
  const profileTemplatesTab = document.querySelector('.nav#profile_templates_tab')
  if (tabContent) {
    tabContent.querySelectorAll('a[data-custom-bs="tab"]').forEach((tabLink) => {
      tabLink.addEventListener('click', (e) => {
        const anchor = tabLink.getAttribute('href')
        var triggerEl = profileTemplatesTab.querySelector(`a[href="${anchor}"]`)
        bootstrap.Tab.getOrCreateInstance(triggerEl).show()
      })
    })
  }
}
